import React from 'react';
import AccountLockIcon from 'mdi-react/AccountLockIcon';

import { EmptyState } from '@crm-framework/empty-state';

import { BaseLayout } from '@crm-package/layouts';

import { Page } from './styles';

export const Unauthorized: React.FC = () => (
  <Page>
    <BaseLayout>
      <EmptyState
        icon={AccountLockIcon}
        header="You are unauthorized"
        description="Try to reload the page and log in"
      />
    </BaseLayout>
  </Page>
);
